import styled from "styled-components";

interface IItemGrid {
	sizeCell: "small" | "medium" | "large";
}
export const ItemGrid = styled.div<IItemGrid>`
	margin: 0;
	padding: ${(props) => (props.sizeCell === "large" ? "10px 0px" : "0px")};
`;

export const BaseTableCellGridMultiline = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 15px;
`;

export const StyledBoxGrid = styled.div`
	@media (max-width: 750px) {
		table {
			min-width: 750px;
		}
	}
`;

interface ITextValue {
	cursor: "default" | "pointer";
	textUnderline?: boolean;
}
export const TextValue = styled.div<ITextValue>`
	display: block;
	text-align: center;
	text-decoration: ${(props) => (props.textUnderline ? "underline" : "default")};
	${(props) =>
		props.cursor === "default" &&
		`
    cursor: default;
    `}
	${(props) =>
		props.cursor === "pointer" &&
		`
    cursor: pointer;
    `}
`;
